'use strict';

module.exports = heading;

var all = require('../all');

/* Transform a heading. */
function heading(h, node) {
  return h(node, 'h' + node.depth, all(h, node));
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-html/~/mdast-util-to-hast/lib/handlers/heading.js
// module id = 705
// module chunks = 168707334958949